import React, { useMemo, Fragment } from 'react';
import RansomwareAttack from './ransomware-attack';
import { observer } from 'mobx-react';
import InstallPlugin from './install-plugin';

function CustomFactory({ ui, onAction, ...rest }) {
    const Component = useMemo(() => {
        switch (ui.variant) {
            case 'ransomwareAttack':
                return RansomwareAttack;
            case 'installPlugin':
                return InstallPlugin;
             default:
                 return Fragment;
        }
    }, [ui]);

    return <Component ui={ui} onAction={onAction} {...rest} />;
}

export default observer(CustomFactory);
